import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router';
import CompanyProfile from '@componentsV2/CompanyProfile';
import useDesktop from '../../../../hooks/useDesktop';
import { publicFetchCompany } from '../../../../api/companies';
import { areIdsEqual } from '../../../../utils/strings';
import { getCompanyId } from '../../../../utils/companies';
import Page from '../../../../components/layouts/WithHeader';
import { sGetCompanies } from '../../../../store/reducers/companies';
import { CompanyProfileLoading } from '../../../../components/CompanyProfileLoading';
import ArrowBackward from '../../../../assets/icons/ArrowBackward';
import Button from '../../../../components/atomic/Button';

const CompanyProfileCmp = ({ companies }) => {
  const [company, setCompany] = useState(null);
  const { companyId } = useParams();
  const isDesktop = useDesktop();
  const history = useHistory();

  const onBackButtonClick = () => {
    history.goBack();
  };

  const fetchCompanyDetails = async () => {
    const [errorResponse, data] = await publicFetchCompany(companyId);
    if (!errorResponse) {
      if (data?.features?.[0]) {
        setCompany({
          ...data,
          features: data.features.map((value) => {
            if (value.imagePath) {
              return {
                ...value,
                url:
                  value.imagePath.includes('http://') ||
                  value.imagePath.includes('https://')
                    ? value.imagePath
                    : `http://${value.imagePath}`,
              };
            }
            return value;
          }),
        });
      } else {
        setCompany(data);
      }
    }
  };

  const selectedCompany =
    Array.isArray(companies) &&
    companies.find((storedCompany) =>
      areIdsEqual(getCompanyId(storedCompany), companyId)
    );

  useEffect(() => {
    if (selectedCompany) {
      setCompany(selectedCompany);
    } else {
      fetchCompanyDetails();
    }
  }, [companyId]);

  return (
    <Page
      minFullHeight
      lessMarginLeft={isDesktop}
      className="max-w-[1060px] mx-auto"
    >
      {isDesktop && (
        <Button
          style={{
            backgroundColor: 'transparent',
            fontSize: '14px',
            marginBottom: '24px',
          }}
          startIcon={
            <ArrowBackward
              style={{ minWidth: '14px', maxHeight: '14px', maxWidth: '14px' }}
            />
          }
          onClick={() => onBackButtonClick()}
        >
          Gå tilbake
        </Button>
      )}

      {!company && <CompanyProfileLoading isLoading />}
      {company && <CompanyProfile company={company} />}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  companies: sGetCompanies(state),
});

export default connect(mapStateToProps, null)(CompanyProfileCmp);
